import { X } from "lucide-react";

interface JobTagProps {
  job: string;
  onRemove: (job: string) => void;
}

const JobTag = ({ job, onRemove }: JobTagProps) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove(job);
  };

  return (
    <span
      className="inline-flex items-center gap-1"
      style={{ color: "#18988B" }}
    >
      <span className="font-semibold" style={{ fontSize: "16px", lineHeight: 1 }}>{job}</span>
      <button
        type="button"
        onClick={handleRemove}
        className="flex items-center justify-center transition-opacity hover:opacity-60"
      >
        <X size={16} />
      </button>
    </span>
  );
};

export default JobTag;
